export { default } from './opacity'
